module.exports = __webpack_public_path__ + "img/dart.a8037724.jpg";